import { useT } from "../../../shared/i18n";
import { Banner, Card, Table, type TableColumn } from "../../../shared/ui";
import type { ExternalIdentity } from "./usersApi";

/** Provider and verification state; the subject only with the PII permission. */
export function IdentitiesSection({
  identities,
  redacted,
}: {
  identities: ExternalIdentity[];
  redacted: boolean;
}) {
  const t = useT();
  const columns: TableColumn<ExternalIdentity>[] = [
    {
      id: "provider",
      header: t("admin.users.identities.provider"),
      cell: (row) => row.provider,
    },
    {
      id: "state",
      header: t("admin.users.identities.state"),
      cell: (row) => row.verification_state,
    },
  ];
  if (!redacted) {
    columns.push({
      id: "subject",
      header: t("admin.users.identities.subject"),
      cell: (row) => row.provider_subject ?? "-",
    });
  }
  return (
    <Card title={t("admin.users.identities.title")}>
      <div className="flex flex-col gap-3">
        {redacted && (
          <Banner tone="info">{t("admin.users.identities.redacted")}</Banner>
        )}
        <Table
          caption={t("admin.users.identities.caption")}
          rows={identities}
          rowKey={(row) => `${row.provider}:${row.provider_subject ?? ""}`}
          empty={
            <p className="text-body text-fg-muted">
              {t("admin.users.identities.none")}
            </p>
          }
          columns={columns}
        />
      </div>
    </Card>
  );
}
